import { JSX } from 'solid-js';

import { splitBindProps, createSingleBind, SingleProps } from './Single';
import { SignalLike, useBind } from '../contexts';

/** 多个绑定 */
export function createMultipleBind<T>(
  props: MultipleProps<T> | SingleProps<T>
): [Accessor<boolean>, () => void, JSX.HTMLAttributes<HTMLElement>] {
  const others = splitBindProps(props as any);
  const ctx = useBind(props.bind as Signal<T[]>);
  if (!(ctx.value instanceof Array)) {
    return createSingleBind(props as any);
  }
  // const [, close] = useToggle();
  ctx.addItem(() => props.value);
  const selected = createMemo(() => ctx.value.includes(props.value));
  function toggle() {
    if (selected()) {
      batch(() => {
        // 多选不触发自动关闭
        // props.close !== false && close(false);
        ctx.toggle(ctx.value.filter((it) => it !== props.value));
      });
    } else {
      ctx.toggle([...ctx.value, props.value]);
    }
  }
  /** 销毁时如果当前被选中，取消选中 */
  createEffect(() => {
    onCleanup(() => {
      queueMicrotask(() => {
        if (selected() && !ctx.items.has(props.value)) {
          toggle();
        }
      });
    });
  });

  return [selected, toggle, others];
}

export interface MultipleProps<T> extends JSX.HTMLAttributes<HTMLDivElement> {
  value: T;
  checked?: boolean;
  disabled?: boolean;
  close?: boolean;
  bind?: SignalLike<T[]>;
}

export interface MixedSelectProps<T> extends JSX.HTMLAttributes<HTMLDivElement> {
  value: T;
  checked?: boolean;
  disabled?: boolean;
  close?: boolean;
  bind?: SignalLike<T[]> | SignalLike<T | undefined>;
}
